import { getAvailableConditionFields } from '@payaca/helpers/automationHelper';
import {
  automationConditionTypeMap,
  automationEntityTypeMap,
  automationTriggerEventMap,
} from './automationMaps';
import type {
  AutomationConditionType,
  AutomationEntityType,
  AutomationTriggerEvent,
} from './types.generated';

/**
 * Returns the GQL condition types available for a given entity type, optionally
 * narrowed by trigger event. GQL-typed wrapper around getAvailableConditionFields
 * in @payaca/helpers.
 */
export function getAvailableConditionTypes(
  entityType: AutomationEntityType,
  triggerEvent?: AutomationTriggerEvent
): AutomationConditionType[] {
  const internalEntityType = automationEntityTypeMap.fromGql[entityType];
  const internalTriggerEvent = triggerEvent
    ? automationTriggerEventMap.fromGql[triggerEvent]
    : undefined;

  // Not all data access types have condition type mappings, so use Partial
  const toGql = automationConditionTypeMap.toGql as Partial<
    Record<string, AutomationConditionType>
  >;

  return getAvailableConditionFields(internalEntityType, internalTriggerEvent)
    .map((f) => toGql[f])
    .filter((t): t is AutomationConditionType => t !== undefined);
}
